<template>
  <app-chart :chartType="chartType" v-if="chartOptions"
    :chartOptions="chartOptions"
    :height="170">
  </app-chart>
</template>

<script>
import { parse, format, differenceInDays } from 'date-fns'
import { getPercentage, thousand } from '@/libs/utils'
import { getTooltipHtml } from '@/libs/chart-helper'
import AppChart from '@/components/chart'

export default {
  name: 'UvAnalytics',
  components: {
    AppChart
  },
  props: [
    'dailyData',
    'isAMP',
    'reportPeriod'
  ],
  computed: {
    isDateOver31 () {
      return differenceInDays(this.reportPeriod.end, this.reportPeriod.start) + 1 > 31
    },
    chartType () {
      return this.isAMP ? 'line' : 'barLine'
    },
    chartOptions () {
      const returnUserLabel = this.isAMP ? null : this.$t('heatmap.cvr_exit.revisit')
      const newUserLabel = this.isAMP ? null : this.$t('heatmap.cvr_exit.new')
      const legendLabels = [returnUserLabel, newUserLabel, 'UV']

      const returnUserSeries = {
        name: legendLabels[0],
        type: 'bar',
        barWidth: 10,
        stack: 'stack-0',
        data: this.dailyData.map(item => {
          return {
            value: item.returnUv,
            itemStyle: {
              barBorderRadius: item.newUv > 0 ? [0, 0, 5, 5] : 5
            }
          }
        })
      }
      const newUserSeries = {
        name: legendLabels[1],
        type: 'bar',
        barWidth: 10,
        stack: 'stack-0',
        data: this.dailyData.map(item => {
          return {
            value: item.newUv,
            itemStyle: {
              barBorderRadius: item.returnUv > 0 ? [5, 5, 0, 0] : 5
            }
          }
        })
      }

      const data = this.dailyData.map(item => {
        return [
          item.timestamp,
          item.uv
        ]
      })
      const uvSeries = {
        name: legendLabels[2],
        type: 'line',
        data: this.isAMP ? data : this.dailyData.map(item => item.uv),
        showSymbol: false,
        symbolSize: 2,
        smooth: true
      }

      let series = []
      if (this.isAMP) {
        series = [uvSeries]
      } else {
        series = [returnUserSeries, newUserSeries, uvSeries]
      }

      const isAMP = this.isAMP

      if (this.isDateOver31) {
        Object.assign(returnUserSeries, {
          areaStyle: 0.5,
          smooth: true,
          type: 'line',
          lineStyle: { width: 0 },
          showSymbol: false
        })
        Object.assign(newUserSeries, {
          areaStyle: 0.5,
          smooth: true,
          type: 'line',
          lineStyle: { width: 0 },
          showSymbol: false
        })
      }

      return {
        tooltip: {
          formatter (params) {
            function getItemContent (item, pvItem) {
              let itemContent

              if (pvItem) {
                const percentage = getPercentage(item.value, pvItem.value, 1)
                itemContent = [
                  `${item.marker}${item.seriesName} : ${thousand(item.value)}`,
                  `${percentage}%`
                ]
              } else {
                itemContent = [
                  `${item.marker}${item.seriesName} :`,
                  thousand(item.value)
                ]
              }

              if (isAMP) {
                itemContent = [`${item.marker}${item.seriesName} : `, item.value[1]]
              }
              return itemContent
            }
            const returnUserData = params.find(item => item.seriesName === legendLabels[0])
            const newUserData = params.find(item => item.seriesName === legendLabels[1])
            const uvData = params.find(item => item.seriesName === legendLabels[2])
            const content = []

            if (returnUserData) {
              content.push(getItemContent(returnUserData, uvData))
            }
            if (newUserData) {
              content.push(getItemContent(newUserData, uvData))
            }
            if (uvData) {
              content.push(getItemContent(uvData))
            }

            if (isAMP) {
              const title = format(parse(params[0].axisValue), 'MM-DD')
              return getTooltipHtml(content, title)
            } else {
              return getTooltipHtml(content, params[0].axisValue)
            }
          }
        },
        xAxis: {
          data: this.dailyData.map(item => format(parse(item.timestamp), 'MM-DD')),
          boundaryGap: !this.isDateOver31
        },
        yAxis: {
          splitNumber: 3
        },
        series: series,
        color: ['#1199af', '#9fce12', '#43b6c9']
      }
    }
  }
}
</script>

<style>

</style>
